import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ScrollPanel } from 'primeng/primeng';
import { MODO_PERSPECTIVA_ITENS_MENU_USUARIO } from '../../../../app.constants';
import { CardsMenuService } from '../../../card-menu/service/cards-menu.service';
import { ValidarPermissaoFuncionalidadeService } from '../../services/validar-permissao-funcionalidades.service';
import { StorafeUtil } from '../../util/storasge.util';


@Component({
    selector: 'app-menu-lateral-paralelo',
    templateUrl: './menu-lateral-paralelo.component.html',
    styles: [],
})
export class MenuLateralParaleloComponent implements OnInit, AfterViewInit {

    @BlockUI() blockUi: NgBlockUI;

    @Output() menuClickAction = new EventEmitter();

    @Output() layoutStaticAction = new EventEmitter();

    @Input() layoutStatic: Boolean;

    @Input() atualizarMenu: Boolean;

    menuClick: Boolean;


    sidebarActive = false;

    layoutStaticValue = false;

    clickSideBarValue = false;

    menu: any[] = [];

    @Input() reset: boolean;

    itensMenu?: any;

    @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ScrollPanel;
    disabledAtualizarInfContatos: boolean;


    constructor(
        private router: Router,
        private validarPermissaoFuncionalidadeService: ValidarPermissaoFuncionalidadeService,
        private cardsMenuService: CardsMenuService
    ) { }




    ngOnInit() {

        this.carregarMenuLateral();
        ValidarPermissaoFuncionalidadeService.atualiazarItemMenu.subscribe(arg => {
            const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
            (modoConsultadoUusario) ? (this.carregarMenuLateral()) : (this.carregarMenuLateral());
        })
    }

    ngAfterViewInit() {
        setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 100);
    }

    async carregarMenuLateral() {
        this.blockUi.start('Carregando...');
        try {
            const itensMenu = await this.validarPermissaoFuncionalidadeService.getItensMenuLateral();
            this.menu = await this.iniciarMenu(itensMenu)
        } catch (error) {
            console.error(error);
        } finally {
            this.blockUi.stop();
        }

    }


    async iniciarMenu(itensMenu): Promise<any[]> {
        return new Promise<any[]>(async (resolve, reject) => {
            if (itensMenu.length !== 0) {
                const pais = await this.findAllPais(itensMenu);
                const filhos = await this.findAllFilhos(itensMenu);
                // const filhosRetorno = await this.remocaoItensMenuFilhosInstitucional(pais, filhos);
                const itens = await this.organizarElementosMenu(pais, filhos)
                resolve(itens);
                // setTimeout(() => {
                // }, 7000);
            }
        })
        // return [];
    }

    remocaoItensMenuFilhosInstitucional(pais, filhos) {
        return new Promise<any[]>((resolve, reject) => {
            // const pai = pais.find(item => item.sgItemMenu.toLowerCase() === 'institucional');
            const pai = pais.find(item => item.sgItemMenu.toLowerCase() === 'clpdf');
            let filhosTratados = [];
            (pai)
                ? filhosTratados = filhos.filter(item => item.itemMenuPai.idItemMenu !== pai.idItemMenu)
                : filhosTratados = filhos;
            resolve(filhosTratados);
        })
    }

    ordenarListaItemMenu(itemMenu) {
        return itemMenu.sort(function (a, b) {
            return (a.irNumeracao > b.irNumeracao) ? 1 : ((b.irNumeracao > a.irNumeracao) ? -1 : 0);
        });

    }


    findAllPais(itensMenuTeste) {

        return new Promise<any[]>((resolve, reject) => {
            let pais = [];
            itensMenuTeste.filter(element => {
                if (!element.itemMenuPai) {
                    (element.sgItemMenu.toLowerCase() === 'início'.toLowerCase()
                        || element.sgItemMenu.toLowerCase() === 'aec'.toLowerCase()
                        || element.sgItemMenu.toLowerCase() === 'mv2020'.toLowerCase())
                        ? (element.dsUrl = element.dsUrl)
                        : (element.dsUrl = '');
                    return pais.push({ idItemMenu: element.idItemMenu, dsIconi: element.dsIconi, dsUrl: element.dsUrl, sgItemMenu: element.sgItemMenu, dsItemMenu: element.dsItemMenu, tpTela: element.tpTela, irNumeracao: element.irNumeracao })
                }
            });
            // || element.dsItemMenu.toLowerCase().indexOf('institucional') !== -1
            pais = this.ordenarListaItemMenu(pais);
            resolve(pais);
        })
    }

    findAllFilhos(itensMenuTeste) {
        return new Promise<any[]>((resolve, reject) => {
            let filhos = itensMenuTeste.filter(element => { return element.itemMenuPai });

            const documentosGerais = itensMenuTeste.find(item => item.sgItemMenu.toLowerCase() === 'clpdf');
            const consultarCPF = itensMenuTeste.find(item => item.sgItemMenu.toLowerCase() === 'cucpf');

            if (documentosGerais) {
                filhos = filhos.filter(item =>
                    (item.itemMenuPai) && (documentosGerais.idItemMenu !== item.itemMenuPai.idItemMenu))
            }

            if (consultarCPF) {
                filhos = filhos.filter(item =>
                    (item.itemMenuPai) && (consultarCPF.idItemMenu !== item.itemMenuPai.idItemMenu))
            }

            resolve(filhos);
        })
    }


    organizarElementosMenu(pais, itensMenuFilhos) {
        return new Promise<any[]>((resolve, reject) => {
            const paisResolve = pais
                .map(pai => {
                    return this.objetoMenu(pai, itensMenuFilhos)
                })
            resolve(paisResolve);
        })
    }

    objetoMenu(pai, itensMenuFilhos) {
        const elementosRecursivos = this.elementosRecursivos(pai, itensMenuFilhos)

        return {
            label: pai.dsItemMenu,
            sigla: pai.sgItemMenu,
            icon: pai.dsIconi,
            routerLink: (pai.dsUrl) ? pai.dsUrl : '',
            tpTela: pai.tpTela,
            items: elementosRecursivos.length === 0 ? null : elementosRecursivos
        }
    }

    correcaoTextoItem(pai) {
        return pai.dsItemMenu.length > 23
            ? pai.sgItemMenu
            : `${pai.dsItemMenu[0].toUpperCase()}${pai.dsItemMenu.substr(1, pai.dsItemMenu.length).toLowerCase()}`
    }

    elementosRecursivos(pai, itensMenuFilhos) {
        const fihosDosFilhos = itensMenuFilhos
            .filter(item => pai.idItemMenu === item.itemMenuPai.idItemMenu)
            .map(paiMaster => {
                return this.objetoMenu(paiMaster, itensMenuFilhos)
            })

        return fihosDosFilhos;
    }



    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
    }



    onSidebarClick() {
        this.menuClickAction.emit({ menuClickAction: true })
        // const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
        // ( modoConsultadoUusario) && (this.carregarMenuLateral())

    }

    onToggleMenuClick() {
        this.layoutStaticAction.emit({ layoutStatic: !this.layoutStatic })
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/menu-lateral/menu-lateral-paralelo.component.ts